import { compact, concat, forEach, get, sortBy, trim, uniq } from 'lodash'

export const SET_FILTER_CONTENT = 'SET_FILTER_CONTENT'

const setFilterContent = (filterContent) => ({
  type: SET_FILTER_CONTENT,
  payload: filterContent,
})

export const fetchFilterContent = (events) => (dispatch) => {
  let locations = []

  forEach(events, (event) => {
    locations = concat(locations, trim(get(event, 'location')), [])
  })

  dispatch(setFilterContent({ locations: sortBy(compact(uniq(locations))) }))
}
